import styled from 'styled-components';
import { Flex, SvgIcon } from '@elementary/common-ui/components';
import Button from '@elementary/common-ui/components/Button';
import testNameByPackageRenderer from '@elementary/common-ui/components/cellRenderers/testNameByPackageRenderer';
import { ReactComponent as ExpandIcon } from '@elementary/common-ui/assets/16x16/expand.svg';
import { space } from '@elementary/common-ui/style/utils';

const NameCell = styled(Flex)`
  align-items: center;
  gap: ${space('sm')};
  width: 100%;
  min-width: 0;
`;

const NameWrapper = styled.div`
  min-width: 0;
  flex: 1;
  overflow: hidden;
`;

const EditButton = styled(Button)`
  display: none;
  flex-shrink: 0;

  tr:hover & {
    display: inline-flex;
  }
`;

type Props<TRow> = {
  row: TRow;
  showEdit: boolean;
  onEdit?: (row: TRow) => void;
};

const PlanPreviewTestNameRenderer = <TRow,>({
  row,
  showEdit,
  onEdit,
}: Props<TRow>) => (
  <NameCell>
    <NameWrapper>{testNameByPackageRenderer(row)}</NameWrapper>
    {showEdit && (
      <EditButton
        size="extraSmall"
        variant="outlined"
        endIcon={
          <SvgIcon width={16} height={16} fillColor="icon.primary">
            <ExpandIcon />
          </SvgIcon>
        }
        onClick={(e) => {
          e.stopPropagation();
          onEdit?.(row);
        }}
      >
        Edit
      </EditButton>
    )}
  </NameCell>
);

export default PlanPreviewTestNameRenderer;
